import type { ProviderUsage } from "./types";

export function relativeTime(value: string, now = Date.now()): string {
  const seconds = Math.round((new Date(value).valueOf() - now) / 1000);
  const formatter = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
  const ranges: Array<[Intl.RelativeTimeFormatUnit, number]> = [
    ["day", 86_400],
    ["hour", 3_600],
    ["minute", 60],
  ];
  for (const [unit, range] of ranges) {
    if (Math.abs(seconds) >= range || unit === "minute") {
      return formatter.format(Math.round(seconds / range), unit);
    }
  }
  return "now";
}

export function summarizeUsage(
  usage: ProviderUsage[],
): Map<string, number> {
  const totals = new Map<string, number>();
  for (const entry of usage) {
    totals.set(entry.provider, (totals.get(entry.provider) ?? 0) + entry.units);
  }
  return totals;
}
